<div class="mainDiv">
  <div class="cardStyle">
    <img *ngIf="!isUrlBasedLogo" src="./../../../../assets/img/tvet-logo-2.png" id="signupLogo" />
    <img *ngIf="isUrlBasedLogo" src="./../../../../assets/img/logo2-new.png" id="signupLogo" />

    <h2 class="formTitle">Vendor Registration</h2>
    <form action="" [formGroup]="myForm" (ngSubmit)="submit(myForm)">
      <div class="row" style="margin: 4px">
        <h4>VENDOR BASIC INFORMATION</h4>
        <div class="col-4 mb-3">
          <label for="exampleFormControlInput1" class="form-label mb-1"><b>Code</b><strong>:</strong><span
              class="text-danger">*</span></label>
          <input type="text" class="form-control form-control1" placeholder="" formControlName="vendor_code" disabled />
          <div *ngIf="myForm.get('vendor_code')?.touched">
            <span class="text-danger" *ngIf="myForm.get('vendor_code')?.hasError('required')">
              Please Enter Vendor Code
            </span>
          </div>
        </div>

        <div class="col-4 mb-3">
          <label for="exampleFormControlInput1" class="form-label mb-1"><b>Registered Business
              Name</b><strong>:</strong></label>
          <input type="text" class="form-control form-control1" id="example1" placeholder=""
            formControlName="organizationName" disabled />
        </div>

        <div class="col-4 mb-3">
          <label for="exampleFormControlInput1" class="form-label mb-1"><b>Trading Name(if
              different)</b><strong>:</strong></label>
          <input type="text" class="form-control form-control1" id="example2" placeholder=""
            formControlName="vreg_trading_name" disabled />
        </div>

        <div class="col-4 mb-3">
          <label for="exampleFormControlInput1" class="form-label mb-1"><b>Business Registration Number/Certificate
              No.</b><strong>:</strong><span class="text-danger">*</span></label>
          <input type="text" class="form-control form-control1" placeholder="" formControlName="org_reg_no" />
          <div *ngIf="myForm.get('org_reg_no')?.touched">
            <span class="text-danger" *ngIf="myForm.get('org_reg_no')?.hasError('required')">
              Please Enter Business Registration Number
            </span>
          </div>
        </div>

        <div class="col-4 mb-3">
          <label for="exampleFormControlInput1" class="form-label mb-1"><b>KRA Number</b><strong>:</strong><span
              class="text-danger">*</span></label>
          <input type="text" class="form-control form-control1 mt-4" placeholder="" formControlName="kra_no" />
          <div *ngIf="myForm.get('kra_no')?.touched">
            <span class="text-danger" *ngIf="myForm.get('kra_no')?.hasError('required')">
              Please Enter KRA Number
            </span>
          </div>
        </div>
        <div class="col-4 mb-3">
          <label for="exampleFormControlInput1" class="form-label mb-1"><b>IFMIS Number</b><strong>:</strong><span
              class="text-danger">*</span></label>
          <input type="text" class="form-control form-control1 mt-4" placeholder="" formControlName="vreg_ifmis_no" />
          <div *ngIf="myForm.get('vreg_ifmis_no')?.touched">
            <span class="text-danger" *ngIf="myForm.get('vreg_ifmis_no')?.hasError('required')">
              Please Enter IFMIS Number
            </span>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="form-group">
            <label class="form-label"><b>Vendor Type</b><strong>:</strong><span class="text-danger">*</span></label>
            <ng-multiselect-dropdown style="width: 100%" [placeholder]="'Select Vendor Type'"
              [settings]="dropdownVendorTypeSettings" [data]="vendorTypeList" (onSelect)="onSelectOne($event)"
              (onSelectAll)="onSelectAll($event)" [(ngModel)]="selectedVendorType"
              formControlName="vreg_vendor_type_id">
            </ng-multiselect-dropdown>
          </div>
        </div>

        <div class="col-4 mb-3">
          <label for="exampleFormControlInput1" class="form-label mb-1"><b>AGPO Number</b><strong>:</strong></label>
          <input type="text" class="form-control form-control1" placeholder="" formControlName="vreg_agpo_no" />
          <div *ngIf="myForm.get('vreg_agpo_no')?.touched">
            <span class="text-danger" *ngIf="myForm.get('vreg_agpo_no')?.hasError('required')">
              Please Enter AGPO Number
            </span>
          </div>
        </div>

        <div class="col-4 mb-3">
          <label class="form-label mb-1">
            <b>Type of Business</b><strong>:</strong>
          </label>

          <select class="form-control form-control1" formControlName="vreg_business_id">

            <option value="" disabled selected>
              -- Select Type of Business --
            </option>

            <option value="1">Sole Proprietor</option>
            <option value="2">Partnership</option>
            <option value="3">Limited Company</option>
            <option value="4">NGO</option>
            <option value="5">LLP</option>
          </select>

          <!-- Validation -->
          <div *ngIf="myForm.get('vreg_type_of_business')?.touched">
            <span class="text-danger" *ngIf="myForm.get('vreg_type_of_business')?.hasError('required')">
              Please select Type of Business
            </span>
          </div>
        </div>


        <div class="row">
          <h4>STATUTORY COMPLIANCE DOCUMENT UPLOADS</h4>

          <div class="col-4 mb-3" *ngFor="let doc of complianceDocs">

            <label class="form-label mb-1">
              <b>{{ doc.label }}:</b>
              <span class="text-danger" *ngIf="doc.required">*</span>
            </label>

            <div class="input-group">
              <input type="file" class="form-control form-control1" accept="application/pdf"
                (change)="onFileChangeNew($event, doc.key)" />

              <span class="input-group-text" style="cursor:pointer; background-color:#ff7f50; color:white"
                (click)="removeFileNew(doc.key)">
                Remove
              </span>
            </div>

            <h6 *ngIf="uploadedFilePaths[doc.key]">
              Your uploaded file,
              <a (click)="viewFileNew(doc.key)" style="cursor:pointer; color:blue;">
                click here
              </a>
              to view.
            </h6>

            <div *ngIf="myForm.get(doc.key)?.touched">
              <span class="text-danger" *ngIf="myForm.get(doc.key)?.hasError('required')">
                Please upload PDF document
              </span>
            </div>

          </div>

        </div>

        <div class="row">
          <h4>PHYSICAL & POSTAL ADDRESS</h4>
          <h6>REGISTERED PHYSICAL ADDRESS:</h6>


          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Country</b><strong>:</strong></label>
            <div class="input-group searchableSelect">
              <ng-select [items]="countryList" bindLabel="cou_country" bindValue="cou_country_id" [searchable]="true"
                formControlName="vreg_country_id" class="form-control" nullToZero>
              </ng-select>
            </div>
            <div *ngIf="myForm.get('vreg_country_id')?.touched">
              <span class="text-danger" *ngIf="myForm.get('vreg_country_id')?.hasError('required')">
                Please Select Country
              </span>
            </div>
          </div>


          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>County</b><strong>:</strong></label>
            <div class="input-group searchableSelect">
              <ng-select [items]="countyList" bindLabel="coun_county_name" bindValue="coun_county_id"
                [searchable]="true" formControlName="county_id" class="form-control" nullToZero>
              </ng-select>
            </div>
            <div *ngIf="myForm.get('county_id')?.touched">
              <span class="text-danger" *ngIf="myForm.get('county_id')?.hasError('required')">
                Please Select County
              </span>
            </div>
          </div>


          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Town</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="town_name" />
            <div *ngIf="myForm.get('town_name')?.touched">
              <span class="text-danger" *ngIf="myForm.get('town_name')?.hasError('required')">
                Please Enter Town
              </span>
            </div>
          </div>

          <h6>POSTAL ADDRESS</h6>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>P.O.Box
              </b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="vreg_address" />
            <div *ngIf="myForm.get('vreg_address')?.touched">
              <span class="text-danger" *ngIf="myForm.get('vreg_address')?.hasError('required')">
                Please Enter P.O.Box
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Postal Code</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="postal_code" />
            <div *ngIf="myForm.get('postal_code')?.touched">
              <span class="text-danger" *ngIf="myForm.get('postal_code')?.hasError('required')">
                Please Enter Postal Code
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Street</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="street_name" />
            <div *ngIf="myForm.get('street_name')?.touched">
              <span class="text-danger" *ngIf="myForm.get('street_name')?.hasError('required')">
                Please Enter Street
              </span>
            </div>
          </div>

          <h4>CONTACT INFORMATION</h4>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Official Email
                Address</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" id="example2" placeholder=""
              formControlName="vreg_email" disabled />
          </div>
          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Telephone
                Number</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" id="example3" placeholder=""
              formControlName="vreg_mobile" disabled />
          </div>

        </div>

        <div class="row">

          <h4>AUTHORIZED CONTACT PERSON</h4>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>First Name</b><strong>:</strong><span
                class="text-danger">*</span></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="vreg_con_firstname" />
            <div *ngIf="myForm.get('vreg_con_firstname')?.touched">
              <span class="text-danger" *ngIf="myForm.get('vreg_con_firstname')?.hasError('required')">
                Please Enter First Name
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Surname</b><strong>:</strong><span
                class="text-danger">*</span></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="vreg_con_lastname" />
            <div *ngIf="myForm.get('vreg_con_lastname')?.touched">
              <span class="text-danger" *ngIf="myForm.get('vreg_con_lastname')?.hasError('required')">
                Please Enter Surname
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Email Address</b><strong>:</strong><span
                class="text-danger">*</span></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="vreg_con_emailId" />
            <div *ngIf="myForm.get('vreg_con_emailId')?.touched">
              <span class="text-danger" *ngIf="myForm.get('vreg_con_emailId')?.hasError('required')">
                Please Enter Email Address
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Mobile Number</b><strong>:</strong><span
                class="text-danger">*</span></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="vreg_con_mobileNo" />
            <div *ngIf="myForm.get('vreg_con_mobileNo')?.touched">
              <span class="text-danger" *ngIf="myForm.get('vreg_con_mobileNo')?.hasError('required')">
                Please Enter Mobile Number
              </span>
            </div>
          </div>

        </div>

        <div class="row">
          <h4>BANK & PAYMENT DETAILS</h4>
          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Bank Name </b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="bank_name" />
            <div *ngIf="myForm.get('bank_name')?.touched">
              <span class="text-danger" *ngIf="myForm.get('bank_name')?.hasError('required')">
                Please Enter Bank Name
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Branch</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="branch" />
            <div *ngIf="myForm.get('branch')?.touched">
              <span class="text-danger" *ngIf="myForm.get('branch')?.hasError('required')">
                Please Enter Branch
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Account Name</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="account_name" />
            <div *ngIf="myForm.get('account_name')?.touched">
              <span class="text-danger" *ngIf="myForm.get('account_name')?.hasError('required')">
                Please Enter Account Name
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Account
                Number</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="vreg_account_no" />
            <div *ngIf="myForm.get('vreg_account_no')?.touched">
              <span class="text-danger" *ngIf="myForm.get('vreg_account_no')?.hasError('required')">
                Please Enter Account Number
              </span>
            </div>
          </div>

          <div class="col-4 mb-3">
            <label for="exampleFormControlInput1" class="form-label mb-1"><b>Bank code</b><strong>:</strong></label>
            <input type="text" class="form-control form-control1" placeholder="" formControlName="bank_code" />
            <div *ngIf="myForm.get('bank_code')?.touched">
              <span class="text-danger" *ngIf="myForm.get('bank_code')?.hasError('required')">
                Please Enter Bank Code
              </span>
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-outline">
              <label class="form-label mb-1"><b>Currency</b><strong>:</strong><span class="text-danger">*</span></label>
              <select class="form-select" formControlName="vreg_currency_id">
                <option value="">Select</option>
                <option *ngFor="let item of currencyList" [value]="item.curr_id">
                  {{ item.curr_currencycode }}-{{ item.curr_name }}
                </option>
              </select>
            </div>
          </div>


        </div>












      </div>
    </form>
    <div class="text-center">
      <button type="submit" (click)="submit(myForm)" class="btn btn-primary" [disabled]="myForm.invalid">
        Submit</button>&nbsp;&nbsp;
      <button type="button" (click)="close()" class="btn btn-danger">
        Close
      </button>
    </div>
  </div>
</div>